import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMoon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "lucide lucide-moon-icon lucide-moon",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z" })
});
export default SvgMoon;
